<!--
    图片列表组件
    作用：右侧工具与工具弹窗；
    实现：通过组件遍历图片列表；
    组件：
        import {isNull} from "../../utils/utils"
        import * as ResultServer from '../../api/resource'
    注释：WJ
-->
<template>
    <div
        class="comp-img-box"
        :class="{isTilte}"
    >
        <div class="box_percent" v-show="show">{{percent}}%</div>
        <div
            class="box"
            @click.stop="onSelect"
            @mouseenter.stop="mouseenter($event)"
            @mouseleave.stop="mouseleave($event)"
        >
            <img crossOrigin="anonymous" v-if="getRealUrl(item)" class="img" :src="getRealUrl(item)" alt="" />
            <span v-else class="img-box-default"><img class="default" :src="$images.material.default+'?imageView2/2/w/123/h/80/q/85#default'" alt="" /></span>
            <span v-if="isBackground"
                  class="set-bg"
                  @click.stop="onBackground"
            >
                <el-tooltip
                        class="item"
                        effect="light"
                        content="设为背景"
                        placement="left"
                        :open-delay="500"
                >
                    <p class="imgs-box">
                      <img class="img" :src="$images.material.setBackground" alt="img" />
                      <img class="img active" :src="$images.material.setBackground1" alt="img" />
                    </p>
                </el-tooltip>
            </span>
        </div>
        <p v-if="isTilte" class="title">{{item.alias || item.name}}</p>
    </div>
</template>

<script>
    import {isNull} from "../../utils/utils"
    import * as ResultServer from '../../api/resource'
    export default {
        name: "comp-img-box",
        props: {
            isTilte: {
                type: Boolean,
                default: false
            },
            item: Object,
            isBackground: {
                type: Boolean,
                default: false
            }
        },
        watch: {
          item(vl){
              this.newItem = vl
            },
        },
        data(){
            return {
                newItem:this.item,
                show:false,
                percent:0,
                id:0,
            }
        },
        mounted(){
            this.getPercent()
        },
        methods: {
            getRealUrl(item){
                let url = ''
                if(item.url && typeof item.url === 'string') {
                    url = item.url
                } else if (item.cover && typeof item.cover === 'string') {
                    url = item.cover
                } else if (item.attributes && item.attributes.url && item.attributes.url === 'string') {
                    url = item.attributes.url
                } else if (item.attributes && item.attributes.cover && item.attributes.cover === 'string') {
                    url = item.attributes.cover
                }
                url+='?imageView2/2/w/123/h/80/q/85#getrealUrl';
                // url = this.$utils.getNewUrl(url)
                return url
            },
            getPercent(){
                this.id=this.newItem.id;
                //if(isNull(this.newItem.attributes.resources.ext_info))return false;
                //this.percent=this.newItem.attributes.resources.ext_info.unpack_progress;

                /*if(this.percent<100 && this.percent>=0){
                    this.getPercentState();
                }else{
                    this.newItem.percent==100;
                    this.show=false;
                }*/
            },
            async getPercentState(){
                this.show=true;
                let obj={id:this.id,clientsId:this.$store.state.initConfig.school_id};
                //getResourceShopDetail getResourceDetail
                const res = await ResultServer.getResourceShopDetail(obj);
                if(res.status_code === 200){
                    if(isNull(res.data.attributes.resources.ext_info)){
                        this.show=false;
                        return false;
                    }
                    this.percent=res.data.attributes.resources.ext_info.unpack_progress;
                    if(this.percent<100 && this.percent>=0){
                        this.show=true;
                        setTimeout(()=>{
                            this.getPercentState();
                        },5000);
                    }else{
                        this.show=false;
                    }
                }else {
                    this.$message.error('编辑失败')
                }
            },
            onBackground(){
                this.$emit('onBackground')
            },
            onSelect(){
                this.$emit('onSelect')
            },
            mouseenter( events){
                this.handleMouseEnterOpen();
                this.$emit('onMouseenter', events)
            },
            mouseleave(events){
                // console.log('ddd')
                this.$emit('onMouseleave', events)
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        }
    }
</script>

<style lang="scss" scoped>
.comp-img-box {
    width: 100%;
    position: relative;
    &.isTilte{
        .box{
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }
    .box_percent{
        width:100%;
        height:100%;
        background-color:rgba(0,0,0,0.5);
        line-height: 80px;
        color:#fff;
        position: absolute;
        top:0px;
        left:0px;
        z-index: 10000;
        text-align:center;
        //display:none;
    }
    .box {
        width: 100%;
        height: 80px;
        position: relative;
        cursor: pointer;
        background: #F0F2F5;
        border-radius: 4px;
        overflow: hidden;

        &>.img{
            transition: transform .3s ease;
            transform: scale(1);

            &:hover{
                transform: scale(1.2);
            }
        }

        .img-box-default {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .default {
                width: 100%;
                height: 100%;
            }
        }

        .txt-box {
            position: absolute;
            width: 100%;
            /*height: 100%;*/
            bottom: 0px;
            left: 0px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .name {
                background: rgba(0, 0, 0, 0.25);
                font-size: 12px;
                padding: 4px;
                color: rgba(255, 255, 255, 0.85);
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
        }

        .set-bg {
            position: absolute;
            bottom: 4px;
            right: 4px;
            width: 18px;
            height: 18px;
            font-size: 12px;
            color: #303133;
            transition: all .2s linear;

            .imgs-box {
                width: 100%;
                height: 100%;

                .img {
                    border-radius: 0px !important;

                    &.active {
                        display: none !important;
                    }
                }

                &:hover {
                    /*background-color: #e7622e;*/

                    .img {
                        display: none !important;

                        &.active {
                            display: inline-block !important;
                        }
                    }
                }
            }
        }

        .img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            /*border-radius: 10px;*/
        }

        .love-box {
            position: absolute;
            top: 8px;
            right: 8px;
            cursor: pointer;

            .img {
                width: 20px;
                height: 18px;
            }
        }
    }

    .title{
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-weight: 400;
        color: #303133;
        line-height: 24px;
        padding: 4px 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>
